export default "/images/vendor/flag-icon-css/flags/4x3/mn.svg?5e4557f7ed743f19592c0f3d5424ad8f";